<template>
  <div>
    <!-- User Interface controls -->
    <b-row>
        <b-col md="7" class="my-1">
            <b-form-group class="mb-0">
                <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search" />
                    <b-input-group-append>
                        <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col md="5" class="my-1">
            <b-form-group label-cols-md="4" label="Per page" class="mb-0">
                <b-form-select :options="pageOptions" v-model="perPage" />
            </b-form-group>
        </b-col>
      </b-row>

    <!-- Main table element -->
    <b-table
      show-empty
      empty-text="There are no preceptors stored at this time."
      striped
      responsive
      stacked="md"
      :items="items"
      :fields="fields"
      :filter="filter"
      :current-page="currentPage" 
      :per-page="perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @filtered="onFiltered"
    >
      <template v-slot:cell(actions)="row" class="text-nowrap">
        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <b-button @click="editPreceptor(row.item.id)" class="btn btn-warning mb-2">
            <span class="icon icon-pencil"> Edit</span>
          </b-button>
          <b-button @click="resetPassword(row.item.id, row.item.email)" class="btn btn-primary mb-2">
            <span class="icon icon-key"> Reset Account</span>
          </b-button>
          <b-button v-if="row.item.hospital.length == 1" @click="info(row.item.name, row.item.id, $event.target)" class="btn btn-danger mb-2">
          <span class="icon icon-trash"> Delete</span>
            </b-button>
            <b-button v-else @click="infoRemove(row.item.name, row.item.id, $event.target)" class="btn btn-info mb-2">
          <span class="icon icon-circle"> Remove</span>
            </b-button>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>
    <!-- Info modal -->
    <b-modal ok-title="Yes Delete" cancel-title="Cancel" ok-variant="danger" cancel-variant="primary" id="modalInfo" @hide="resetModal" @ok="deletePreceptor" :title="modalInfo.title">
      <h4>{{ modalInfo.content }}</h4>
    </b-modal>
    <b-modal ok-title="Yes Remove" cancel-title="Cancel" ok-variant="danger" cancel-variant="primary" id="modalInfoRemove" @hide="resetModal" @ok="removePreceptor" :title="modalInfo.title">
      <h4>{{ modalInfo.content }}</h4>
    </b-modal>
  </div>
</template>

<script>
const items = [];
export default {
  props: ["preceptors"],
  data() {
    return {
      items: this.preceptors,
      fields: [
        {
          key: "name",
          label: "Preceptor"
        },
        {
          key: "actions",
          label: "Actions"
        }
      ],
      filter: null,
      sortBy: "name",
      sortDesc: false,
      currentPage: 1,
      perPage: 25,
      totalRows: this.preceptors.length,
      pageOptions: [15, 25, 35, 50],
      modalInfo: { title: '', content: '', id: '' }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  filters: {
    uppercase: function(v) {
      return v.toUpperCase();
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    info(name, id, button) {
        this.modalInfo.title = `Are you sure you want to delete?`
        this.modalInfo.content = name
        this.modalInfo.id = id
        this.$root.$emit('bv::show::modal', 'modalInfo', button)
      },
    infoRemove(name, id, button) {
        this.modalInfo.title = `Are you sure you want to remove?`
        this.modalInfo.content = name
        this.modalInfo.id = id
        this.$root.$emit('bv::show::modal', 'modalInfoRemove', button)
      },
    resetModal() {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
      this.modalInfo.id = ''
    },
    deletePreceptor(id) {
        this.modalInfo.title = ''
        this.modalInfo.content = ''
        window.location.href = "/instructor/preceptors/delete/" + this.modalInfo.id;
    },
    removePreceptor(id) {
        this.modalInfo.title = ''
        this.modalInfo.content = ''
        window.location.href = "/instructor/preceptors/remove/" + this.modalInfo.id;
    },
    editPreceptor(id) {
      window.location.href = "/instructor/preceptors/edit/" + id;
    },
    resetPassword(id, email) {
      axios.post('/instructor/preceptors/reset', {
            user_id: id,
            email: email
        })
            .catch(function (error) {
                // handle error
                console.log(error);
            });
            swal({
          title: "User Info Reset!",
          icon: "success"
        });
    },  
  }
};
</script>

<!-- table-complete-1.vue -->